import { Stack } from '@mui/material';
import RichText, { RichTextContent } from '../../../RichText';

type Props = {
  title?: RichTextContent;
  subTitle?: RichTextContent;
};

const Title = ({ title, subTitle }: Props) => {
  return (
    <Stack
      spacing={1.5}
      component={'hgroup'}
      sx={{
        flex: 1,
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <RichText withTypography variant={'subtitle1'} component={'h3'}>
        {title}
      </RichText>
      <RichText withTypography color={'textSecondary'} component={'p'}>
        {subTitle}
      </RichText>
    </Stack>
  );
};

export default Title;
